export const GET_VENDOR_MEMBER_COLUMNS_REQUEST =
  "get_vendor_member_columns_request";
export const GET_VENDOR_MEMBER_COLUMNS_SUCCESS =
  "get_vendor_member_columns_success";
export const GET_VENDOR_USER_COLUMNS_REQUEST =
  "get_vendor_user_columns_request";
export const GET_VENDOR_USER_COLUMNS_SUCCESS =
  "get_vendor_user_columns_success";
export const SET_VENDOR_USER_COLUMNS_REQUEST =
  "set_vendor_user_columns_request";
export const SET_VENDOR_USER_COLUMNS_SUCCESS =
  "set_vendor_user_columns_success";
